import type { GraphPathLookupHostToDefaultGWParameters } from '@ipfabric/utils';
import { isVrfAutodetect } from 'components/Graph/GraphSidePanel/GraphPathlookup/helpers/isVrfAutodetect';
import { PATH_LOOKUP_GROUP_BY } from 'components/Graph/model/pathLookup';
import type { Vrf } from './fetchVrf';

export interface HostToDefaultGWFormValues {
  startingPoint: string;
  vrf: Vrf | null;
}

export const hostToDefaultGWFormValuesToParameters = (
  values: HostToDefaultGWFormValues,
): GraphPathLookupHostToDefaultGWParameters => ({
  ...(!isVrfAutodetect(values.vrf) && { vrf: values.vrf }),
  groupBy: PATH_LOOKUP_GROUP_BY,
  pathLookupType: 'hostToDefaultGW',
  startingPoint: values.startingPoint,
  type: 'pathLookup',
});

export const hostToDefaultGWParametersToFormValues = (
  request: GraphPathLookupHostToDefaultGWParameters,
): HostToDefaultGWFormValues => ({
  startingPoint: request.startingPoint,
  vrf: request.vrf ?? null,
});
